import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import Users from "./admin/users"

function Router( { history, base } ) {

  return (
    <Switch>
      <Route path={`${base}`}>
        <Users />
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
